import jwt_decode from 'jwt-decode';
import type { JWTPayload, LocalStorageDSCVRUser } from './types';

class TokenService {
  getLocalRefreshToken() {
    const user = JSON.parse(localStorage.getItem('gated-user') || '{}');
    return user?.refreshToken;
  }

  getLocalAccessToken() {
    const user = JSON.parse(localStorage.getItem('gated-user') || '{}');
    return user?.token;
  }

  updateLocalAccessToken(token: string) {
    const user = JSON.parse(localStorage.getItem('gated-user') || '{}');
    user.token = token;
    localStorage.setItem('gated-user', JSON.stringify(user));
    this.writeTokenCookie(token);
  }

  getUser() {
    return JSON.parse(localStorage.getItem('gated-user') || '{}');
  }

  setUser(user: LocalStorageDSCVRUser) {
    localStorage.setItem('gated-user', JSON.stringify(user));
    this.writeTokenCookie(user.token);
  }

  removeUser() {
    localStorage.removeItem('gated-user');
    this.deleteTokenCookie();
  }

  writeTokenCookie(token: string) {
    const domain = '.dscvr.one';
    const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
    document.cookie = `dscvr_auth_token=${encodeURIComponent(
      token,
    )}; domain=${domain}; expires=${expires.toUTCString()}; path=/; SameSite=Lax; Secure`;
    console.log('wrote verification token');
  }

  deleteTokenCookie() {
    const domain = '.dscvr.one';
    const expires = new Date(0);
    document.cookie = `dscvr_auth_token=; domain=${domain}; expires=${expires.toUTCString()}; path=/; SameSite=Lax; Secure`;
  }

  checkValidToken() {
    const token = this.getLocalAccessToken();
    if (token) {
      const decoded = jwt_decode(token) as JWTPayload;
      const notExpired = Date.now() < decoded.exp * 1000;
      if (!notExpired) {
        this.removeUser();
      }
      if (notExpired) {
        this.writeTokenCookie(token);
      }
      return notExpired;
    }
    return false;
  }
}
export default new TokenService();
